// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-item[data-v-5623c546]{width:100%;margin-top:10px}.button-item[data-v-5623c546]:hover{background:#72d395;transition:.2s ease-in}.min-height-12[data-v-5623c546]{min-height:48px}.tooltip[data-v-5623c546]{visibility:hidden}.tooltipA:hover .tooltip[data-v-5623c546]{visibility:visible}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
